/**
 * Keeps the selected Echo mission's analysis current: while a mission is open,
 * re-fetches its detail on an interval and merges fresh analysis outputs into
 * the store, so new AI summaries appear without a manual refresh. A lightweight
 * live channel over the pull API the bridge already exposes.
 */

import { useEffect } from 'react';
import { apiClient } from '@/services/api-client';
import { useMissionsStore } from '@/stores/missions-store';

/** How often to pull fresh analysis while a mission is open. */
const POLL_MS = 20_000;

/** Poll the open mission's detail and merge updated analysis into the store. */
export function useMissionAnalysisLive(joinCode: string | null): void {
  useEffect(() => {
    if (!joinCode) return;
    let cancelled = false;

    async function refresh(): Promise<void> {
      const detail = await apiClient.getEchoMissionDetail(joinCode ?? '');
      if (!cancelled && detail) useMissionsStore.getState().setSelectedDetail(detail);
    }

    const id = setInterval(refresh, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [joinCode]);
}
